import React, { useState } from 'react';
import { Card, Input, Button, Typography, Space } from 'antd';
import { UserOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

export default function LoginPage({ onLogin }) {
  const [username, setUsername] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleLogin = async () => {
    if (!username.trim()) {
      setError('请输入用户名');
      return;
    }
    setLoading(true);
    setError('');
    try {
      const res = await fetch('/api/user/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username: username.trim() })
      });
      if (!res.ok) {
        const data = await res.json();
        throw new Error(data.error || '登录失败');
      }
      onLogin(username.trim());
    } catch (e) {
      setError(e.message);
    }
    setLoading(false);
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', background: '#f0f2f5', padding: 16 }}>
      <Card style={{ width: '100%', maxWidth: 400, textAlign: 'center' }}>
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
          <Title level={2} style={{ margin: 0 }}>八字排盘系统</Title>
          <Text type="secondary">输入用户名即可使用</Text>
          <Input
            size="large"
            prefix={<UserOutlined />}
            placeholder="请输入用户名"
            value={username}
            onChange={e => setUsername(e.target.value)}
            onPressEnter={handleLogin}
          />
          {error && <Text type="danger">{error}</Text>}
          <Button type="primary" size="large" block loading={loading} onClick={handleLogin}>
            进入系统
          </Button>
        </Space>
      </Card>
    </div>
  );
}
